import { fetchFlask } from '../../utils/fetchFlask';
import { parseNumberPtBr } from '../../utils/numberUtils';

export const CRM_INFLUENCER_LEADS_API = 'crm/leadsInfluencers';
export const INFLUENCER_DASHBOARD_PAGE_SIZE = 5000;
export const INFLUENCER_TABLE_PAGE = 1;
export const INFLUENCER_TABLE_PAGE_SIZE = 50;
export const INFLUENCER_TABLE_PAGE_SIZE_OPTIONS = [25, 50, 100];

const CONTRACTED_STATUS = 'Concluído';
const CONTRACTED_PHASE = 'Conquistado';

const isContractedLead = (lead) => lead.status === CONTRACTED_STATUS || lead.fase === CONTRACTED_PHASE;

const groupRowsByField = (rows, field) => {
    const grouped = rows.reduce((acc, row) => {
        const key = row[field] ?? '';
        const current = acc.get(key) || { label: key, leads: 0, contracted: 0, kwh: 0 };
        const contracted = isContractedLead(row);

        current.leads += 1;
        current.contracted += contracted ? 1 : 0;
        current.kwh += contracted ? parseNumberPtBr(row.ticket) : 0;
        acc.set(key, current);

        return acc;
    }, new Map());

    return Array.from(grouped.values()).sort((a, b) => b.leads - a.leads);
};

const buildStagePerformance = (rows) => groupRowsByField(rows, 'fase').slice(0, 6);

export const buildInfluencerDashboardViewModel = (data) => {
    const rows = data.items ?? [];
    const totalLeads = rows.length;
    const contractedLeads = rows.filter(isContractedLead).length;
    const soldKwh = rows
        .filter(isContractedLead)
        .reduce((sum, row) => sum + parseNumberPtBr(row.ticket), 0);
    const conversionRate = totalLeads > 0 ? Math.round((contractedLeads / totalLeads) * 100) : 0;

    return {
        totalLeads,
        contractedLeads,
        conversionRate,
        soldKwh,
        stagePerformance: buildStagePerformance(rows),
        opportunities: [...rows]
            .sort((a, b) => parseNumberPtBr(b.ticket) - parseNumberPtBr(a.ticket))
    };
};

export const buildParceiroLink = (coupon) => {
    if (coupon === 'NORBANK') {
        return 'https://settaenergia.com.br/norbank/?utm_campaign=norbank-2026&utm_source=parceiro&utm_medium=link&utm_content=botao-plataforma&parceiro_id=32&cupom=NORBANK';
    }

    return `https://settaenergia.com.br/?origin=inf&utm_source=${coupon ?? ''}`;
};

export const fetchCrmInfluencerLeads = async () => {
    const response = await fetchFlask(CRM_INFLUENCER_LEADS_API, JSON.stringify({
        page: 1,
        page_size: INFLUENCER_DASHBOARD_PAGE_SIZE
    }));

    return response.data ?? response;
};
